import sdl from '@jds/react-generated-sdl/JDSDropdownMenuItem';
import type { JDSDropdownMenuItemProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, DropdownMenuItemProps } from '../logic';

const Component = (props: DropdownMenuItemProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'single-select',
    selected = false,
    disabled = false,
    ariaLabel = props.label?.toString(),
    _ariaHaspopup = props._hasSubMenu?.toString(),
    _ariaExpanded = props.selected?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      kind,
      selected,
      disabled,
      ariaLabel,
      _ariaHaspopup,
      _ariaExpanded,
      ...rest
    },
    'JDSDropdownMenuItem',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DropdownMenuItem = withLogic(
  Component
) as React.FC<DropdownMenuItemProps> & { slotName?: string };

DropdownMenuItem.displayName = 'DropdownMenuItem';
DropdownMenuItem.slotName = 'jds_dropdown_menu_item';

export { DropdownMenuItem, type JDSDropdownMenuItemProps };
